import {Grid, Tab, Tabs} from "@mui/material";
import {theme} from "../../Tema";
import {useState} from "react";

export const usePestanasFormularios = ({pestanas, Formularios, props}) => {
    const [escogido, setEscogido] = useState(pestanas[0]);


    const mostrarFormulario = (esco) =>{


        let index = pestanas.findIndex((e) => e=== esco);
      //return index

        return Formularios[index]

    }

    const Pestanas = () => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Tabs
                        value={escogido}
                        variant={'standard'}
                        onChange={(e, v) => setEscogido(v)}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: '#047C99', // Tu color de acento
                                height: '4px',
                                borderRadius: '3px 3px 0 0',
                            },
                        }}
                        sx={{
                            borderBottom: '1px solid #E4E7EB',
                            minHeight: '36px',
                            height: '36px',
                            transition: 'all 0.2s ease',
                        }}
                    >

                        {pestanas.map((item, index) => (
                            <Tab
                                label={item}
                                value={item}
                                sx={{
                                    minHeight: '36px',
                                    height: '36px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: 14,
                                    backgroundColor: theme.palette.primary.main + 50,
                                    color: theme.palette.primary.main,
                                    transition: 'all 0.2s ease',
                                    borderTopRightRadius: 10,
                                    borderTopLeftRadius: 10,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.main + 90,
                                    },

                                    '&.Mui-selected': {
                                        backgroundColor: theme.palette.primary.main,
                                        color: '#fff',
                                    },
                                    py: 0
                                }}
                            />
                        ))}




                    </Tabs>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    {mostrarFormulario(escogido)}
                </Grid>


            </Grid>
        )
    }

    return {
        Pestanas
    }


}